import React, {useRef} from 'react';

import {IMG_DIR} from '#Client/components/constants';
import {
  crunchLogo,
  crunchLogoContainer,
  headerContainer,
  headerContainerImage,
} from '#Client/components/Header/Header.css';

type HeaderProps = {
  openMenu: () => void;
  openWhatIsNewModal: () => void;
  viewedNewsIndex?: number;
};

export const NEWS_INDEX = 3;

export const Header = ({
  openMenu,
  openWhatIsNewModal,
  viewedNewsIndex,
}: HeaderProps) => {
  const titleRef = useRef<HTMLHeadingElement>(null);
  const crunch = () => {
    if (!titleRef.current) {
      return;
    }
    titleRef.current.style.animation = 'none';
    titleRef.current.offsetHeight;
    titleRef.current.style.animation = '';
  };
  return (
    <div className={headerContainer}>
      {(typeof viewedNewsIndex !== 'number' ||
        viewedNewsIndex < NEWS_INDEX) && (
        <img
          className={headerContainerImage}
          height="256"
          src={`${IMG_DIR}icon_message.png`}
          width="256"
          onClick={openWhatIsNewModal}
        />
      )}
      <div className={crunchLogoContainer}>
        <h1 className={crunchLogo} ref={titleRef} onClick={crunch}>
          Word&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Crunch
        </h1>
      </div>
      <img
        className={headerContainerImage}
        height="256"
        src={`${IMG_DIR}icon_settings.png`}
        width="256"
        onClick={openMenu}
      />
    </div>
  );
};
